import React, { Component, Fragment } from 'react'
import classnames from 'classnames'

interface TextAreaFieldProps {
  /** textarea name attribute */
  name: string
  /** textarea id + used for label htmlFor */
  id: string
  /** placeholder text */
  placeholder?: string
  /** label text displayed above the textarea */
  label: string
  /** React ref to the underlying <textarea> element */
  reference?: React.Ref<HTMLTextAreaElement>
  /** when true, applies error styles and shows error message list */
  error?: boolean
  /** error/help message content */
  message?: React.ReactNode
  /** number of visible text rows (prop kept as `row` to match original API) */
  row?: number
  /** default value for uncontrolled textarea */
  defaultValue?: string
}

class TextAreaField extends Component<TextAreaFieldProps> {
  private dataQa: string

  // eslint-disable-next-line no-useless-constructor
  constructor(props: TextAreaFieldProps) {
    super(props)
    this.dataQa = 'Textarea-' + props.id
  }

  render() {
    const { name, id, placeholder, reference, error, label, message, row, defaultValue } =
      this.props

    return (
      <Fragment>
        <div className={`Input-group ${!error && 'u-marginBottom24'}`}>
          <label className='Input-label u-marginBottom4' htmlFor={id}>
            {label}
          </label>
          <textarea
            className={classnames('Textarea', {
              'Input--error': error === true,
            })}
            name={name}
            data-qa={this.dataQa}
            id={id}
            placeholder={placeholder}
            ref={reference}
            rows={row}
            defaultValue={defaultValue}
          />
        </div>

        {error && (
          <ul className='Input-errorList u-paddingTop4 u-marginBottom8 u-marginLeft4 u-marginTop0'>
            <li className='Form-help Form-help--error' data-qa={'InputError-' + id}>
              <span
                aria-hidden='true'
                className='Input-icon Icon'
                dangerouslySetInnerHTML={{ __html: '&#xE002' }}
              />
              <span>{message}</span>
            </li>
          </ul>
        )}
      </Fragment>
    )
  }
}
export { TextAreaField }
export default TextAreaField
